export default __webpack_public_path__ + "static/raricapital-cb10cbf48925da19ae8dd40e673f387a.jpg";